// The client ID is simply a UUIDv4 that is assigned to an application

export const FinancingApiClientId = '6894c921-b7b2-4d94-bdd9-f88d0a8e5d2d';

export const HomeApiClientId = '3524274f-e553-411e-89f2-d3f1d3d9134f';

export const MerchUiApiClientId = '40b6459c-f085-455f-ae19-d8070cbf9f5c';

export const SearchApiClientId = '66e36b10-7015-475f-97a9-e9244c67a604';

export const VehicleDetailsApiClientId = 'e902dfb1-f373-450d-8cca-9db2e12bfce5';
